'use es6';

import GenericNoContentDueToFilteringError from './GenericNoContentDueToFilteringError';
import { jsx as _jsx } from "react/jsx-runtime";
const WizardNoResultsError = () => /*#__PURE__*/_jsx(GenericNoContentDueToFilteringError, {
  headingI18n: "noResultsFound",
  subtitleI18n: "refineResults"
});
export default WizardNoResultsError;